{{ dataItem['playbook_category']?.name }}